var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},[React.createElement("path",{"style":{"fill":"none","strokeWidth":"1","strokeLinecap":"round","strokeLinejoin":"round","stroke":"rgb(100%,100%,100%)","strokeOpacity":"1","strokeMiterlimit":"4"},"d":"M 10 0.833333 L 10 19.166667 ","transform":"matrix(3,0,0,3,0,0)","key":0}),React.createElement("path",{"style":{"fill":"none","strokeWidth":"1","strokeLinecap":"round","strokeLinejoin":"round","stroke":"rgb(100%,100%,100%)","strokeOpacity":"1","strokeMiterlimit":"4"},"d":"M 19.166667 10 L 0.833333 10 ","transform":"matrix(3,0,0,3,0,0)","key":1})]));
}

Add.defaultProps = {"width":"60px","height":"60px","viewBox":"0 0 60 60","version":"1.1"};

module.exports = Add;

Add.default = Add;
